// German for the three empty states and the degraded-zone sheet (src/shared/problems.ts
// EMPTY_TITLE / EMPTY_TEXT, rendered by src/client/components/EmptyState.tsx). Keyed by the
// English text, so a component that wraps the same sentence in `t()` picks these up whether it
// reads the constants or spells the text out.
import { registerDe } from './index.js';

registerDe({
  'Could not load': 'Konnte nicht geladen werden',
  'Nothing matches': 'Nichts passt',
  'Nothing here yet': 'Noch nichts vorhanden',
  'Nothing was written.': 'Es wurde nichts geschrieben.',
  'Try again': 'Erneut versuchen',
  'Clear the filter': 'Filter zurücksetzen',
  '{zone} could not be computed': '{zone} konnte nicht berechnet werden',
  'The {source} source answered: “{message}”': 'Die Quelle {source} antwortete: «{message}»',
}, 'problems');
